import AppConfigurationService from '../../../services/app-configuration-service/app-configuration-service';

export const nameplateMakeModelYearUtil = (
    model: string,
    year: number | string,
    make?: string
) => {
    const appConfig = new AppConfigurationService();
    const frenchCanadaLanguageRegionCode = appConfig.currentLanguageRegionCode;

    if (frenchCanadaLanguageRegionCode === 'fr-ca') {
        return make ? `${make} ${model} ${year}` : `${model} ${year}`;
    } else {
        return make ? `${year} ${make} ${model}` : `${year} ${model}`;
    }
};
